import React from 'react'
import { PieChart, ResponsiveContainer, Pie, Cell, Tooltip } from 'recharts'
import { useRecoilValue } from 'recoil';
import { analyticData } from '../../../recoil/analytic';

const GradeChart = () => {
  const analytic = useRecoilValue(analyticData);
  const data = analytic.grade_data;
  const COLORS = ['#38bdf8', '#34d399', '#facc15', '#f87171', '#a78bfa'];

  return (
    <div className="w-1/2 h-72">
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={data}
            innerRadius={80}
            outerRadius={100}
            fill="#8884d8"
            paddingAngle={5}
            dataKey="value"
            label
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip/>
        </PieChart>
      </ResponsiveContainer>
      
    </div>
  )
}

export default GradeChart